<template>
    <div class="modal" :class="{ 'modal-show': show }">
        <div class="box">
            <div style="width:360px;height:300px;">
                <div class="model-body">
                    <dl>
                        <h5>发送验证码</h5>
                        <span @click="closeModel">x</span>
                    </dl>
                    <p>
                        <img
                            alt="图形验证码"
                            @click="editCaptcha"
                            :src="'/api/common/getImgCode' + captcha"
                        />
                    </p>
                    <p>
                        <input
                            type="text"
                            placeholder="请输入验证码"
                            v-model="imgCode"
                        />
                    </p>
                    <p class="wrong" v-text="codeWrong" ref="bindImg"></p>
                    <p>
                        <button @click="getResetCode">确定</button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { sendWxSmsCode } from "@/requests/safe";
// 一级模态窗
export default {
    name: "imgCode",
    props: {
        show: Boolean
    },
    data() {
        return {
            imgCode: "",
            codeWrong: "",
            captcha: ""
        };
    },
    methods: {
        closeModel() {
            this.$emit("sendShow", false);
        },
        // 刷新验证码
        editCaptcha() {
            this.captcha = "?" + Math.random();
        },
        async getResetCode() {
            let obj = {
                imgCode: this.imgCode
            };
            let res = await sendWxSmsCode(obj);
            if (res.code == 200) {
                this.$emit("sendShow", false);
            } else {
                this.$domFn.shake(this.$refs.bindImg);
                this.codeWrong = res.msg;
            }
        }
    },
    mounted() {
        this.editCaptcha();
    }
};
</script>

<style lang="scss" scoped>
.modal {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    // background: rgba(0, 0, 0, 0.6);
    // opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
    z-index: 11;
    & .box {
        max-height: 100%;
        max-width: 100%;
        overflow: auto;
        color: #000;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-60%);
        transition: all 0.3s;
    }
}

// 模态窗显示样式
.modal-show {
    opacity: 1;
    // display: block;
    visibility: visible;
    & .box {
        transform: translateX(-50%) translateY(-50%);
    }
}
.box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
}
.model-body {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 360px;
    height: 300px;
    background-color: #fff;
    h5 {
        // width: 100%;
        background: #363636;
        border-left: 8px solid #09f;
        line-height: 40px;
        color: #fff;
        text-align: left;
        padding-left: 13px;
        margin: 0;
    }
    span {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
    }
    span:hover {
        color: #f00;
    }
    p {
        img {
            width: 180px;
            height: 50px;
            display: block;
            margin: 24px auto;
        }
        input {
            margin-top: 10px;
            height: 60px;
            width: 100%;
            padding: 0;
            border-radius: 0px;
            color: #333;
            font-size: 16px;
            line-height: 60px;
            border: 0px;
            border-bottom: 1px solid #a1a1a1;
            text-align: center;
        }
        button {
            width: 128px;
            margin: 0 auto;
            padding: 0;
            font-size: 18px;
            height: 40px;
            line-height: 40px;
            background: #09c;
            color: #fff;
            border: 0;
        }
    }
    .wrong {
        color: #f33;
        font-size: 12px;
        line-height: 28px;
        height: 28px;
        margin: 8px 0;
        text-align: center;
    }
}
</style>
